module.exports = __webpack_public_path__ + "static/img/image-error.3945077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-error.png
// module id = ss86
// module chunks = 132